module.exports = __webpack_public_path__ + "img/Ellipse.d30cc814.svg";